module.exports = __webpack_public_path__ + "static/media/ronda.e6fc62c2.jpeg";